module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 1.32672","quantity":0.01327},{"color":"#9dc4b5","label":" 1.32672- 1.32672","quantity":0.01327},{"color":"#e6efc3","label":" 1.32672- 1.59631","quantity":0.01596},{"color":"#ffe89e","label":" 1.59631- 2.15957","quantity":0.0216},{"color":"#f5af7f","label":" 2.15957- 3.15885","quantity":0.03159},{"color":"#ed6d32","label":" 3.15885- 10.78504","quantity":0.10785}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_70_return_20.json
// module id = YCVM
// module chunks = 171